import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=0b5bc02d&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5bc02d')) {
      api.createRecord('0b5bc02d', component.options)
    } else {
      api.reload('0b5bc02d', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=0b5bc02d&", function () {
      api.rerender('0b5bc02d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/comp/ImgFallback.vue"
export default component.exports